import { DefaultService } from '../DefaultService';

export default class BandeiraService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(lps) {
        return this._http.post(`${this._env}/promotor/bandeira`, lps, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/bandeira/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findByRede(id, page = 0, limit = 50, ...params) {
        return this._http
            .get(
                `${
                    this._env
                }/promotor/bandeira/network/${id}.json?page=${page}&limit=${limit}&param=${params}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/bandeira/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column, order, page = 0, limit = 50, situacao = 2, ...params) {
        if (!params) params = '';
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/bandeira.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllCombo(limit = 50, situacao = 2, ...params) {
        if (!params) params = '';
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/getcombo/division.json?limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(bandeira) {
        return this._http
            .post(`${this._env}/promotor/bandeira/updatesituacao`, bandeira, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
